import { useApi } from '@shared/api'
import type { Category } from '@entities/product'

const BASE = '/admin/categories'

export const apiAdminCategory = {
  async getAll(): Promise<Category[]> {
    const { data } = await useApi(true, true).get<Category[]>(BASE)
    return data
  },

  async getById(id: number): Promise<Category> {
    const { data } = await useApi(true, true).get<Category>(`${BASE}/${id}`)
    return data
  },

  async create(payload: Omit<Category, 'id'> | FormData): Promise<Category> {
    const { data } = await useApi(true, true).post<Category>(BASE, { body: payload })
    return data
  },

  async update(id: number, payload: Partial<Category> | FormData): Promise<Category> {
    const { data } = await useApi(true, true).patch<Category>(`${BASE}/${id}`, { body: payload })
    return data
  },

  async delete(id: number): Promise<void> {
    await useApi(true, true).delete(`${BASE}/${id}`)
  },

  async deleteImage(id: number, imageKey: string): Promise<{ message: string; remainingImages: number }> {
    const { data } = await useApi(true, true).delete<{ message: string; remainingImages: number }>(
      `${BASE}/${id}/img/${encodeURIComponent(imageKey)}`,
    )
    return data
  },

  async reorder(categories: Array<{ id: number; sort_order: number }>): Promise<{ message: string; updated: number }> {
    const { data } = await useApi(true, true).patch<{ message: string; updated: number }>(
      `${BASE}/reorder`,
      { body: { categories } },
    )
    return data
  },
}

export default apiAdminCategory
